module.exports = {
  "country": "RU",
  "artist": "Little Big ",
  "song": "Uno",
  "year": "2020",
  "place": "CCL",
  "spotify": "1ucAgkQ4EQDCSXQ2kEk99k"
};